<template>
  <div
    class="slide-content"
    v-on:mouseover="mouseover"
    v-on:mouseleave="mouseleave"
    v-if="isMediaLoaded && isValuesLoaded"
  >
    <div class="slideImage" v-show="!selecting">
      <img class="img-carousel" :src="imagePath" />
      <img id="logo" class="logo" :src="logoPath" v-if="marque !== 'essilor'" />
      <img id="logo-essilor" class="logo-essilor" :src="logoPath" v-else />
    </div>
    <div class="selectMenu" v-show="selecting">
      <div class="logo-container">
        <img class="logo-essi" :src="logoPathBlack" v-if="marque !== 'essilor'" />
        <img class="logo-essi-first" :src="logoPathBlack" v-else />
      </div>
      <div class="link-container" v-if="marque !== 'essilor'">
        <button
          class="productButton"
          v-for="product in marque.products"
          v-bind:key="product.name"
          :value="product.name"
          v-on:click="goToConfigurator(product)"
        >
          {{ product.name }}
        </button>
      </div>
      <!--      TODO: A rendre dynamique-->
      <div class="container-intro" v-if="marque === 'essilor'">
        <span class="intro" v-html="getWebcontrol('Produits-Texte-DescriptionEssilor')" />
        <br />
        <span class="introSmall" v-html="getWebcontrol('Produits-Texte-DescriptionEssilorPetit')" />
      </div>

      <div class="link-container essilor" v-if="marque === 'essilor'">
        <div class="link-video" v-if="getWebcontrol('Produits-Bouton-PourquoiEssilor') !== ''">
          <img src="../assets/ic-play.svg" />
          <button @click="goToVideo('Produits-Bouton-PourquoiEssilor')" class="productButton">
            {{ getWebcontrol('Produits-Bouton-PourquoiEssilor') }}
          </button>
        </div>
        <div class="link-video" v-if="getWebcontrol('Produits-Bouton-FabricationVerre') !== ''">
          <img src="../assets/ic-play.svg" />
          <button @click="goToVideo('Produits-Bouton-FabricationVerre')" class="productButton">
            {{ getWebcontrol('Produits-Bouton-FabricationVerre') }}
          </button>
        </div>
        <div class="link-video" v-if="getWebcontrol('Produits-Bouton-OrigineGarantie') !== ''">
          <img src="../assets/ic-play.svg" />
          <button @click="goToVideo('Produits-Bouton-OrigineGarantie')" class="productButton">
            {{ getWebcontrol('Produits-Bouton-OrigineGarantie') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['marque', 'hover'],
  data() {
    return {
      selecting: false,
      hasSelected: false,
    };
  },
  computed: {
    isMediaLoaded() {
      return this.$store.getters.isMediasLoaded();
    },
    isValuesLoaded() {
      return this.$store.getters.isValuesLoaded();
    },
    imagePath() {
      if (this.marque === 'essilor') {
        var mediaEssilor = this.$store.getters.getMediaById('Produits-Image-' + this.marque);
        if (mediaEssilor.url) {
          return mediaEssilor.url;
        } else {
          return require(`../assets/image-marque/${mediaEssilor.filename}`);
        }
      } else {
        var mediaProduct = this.$store.getters.getMediaById('Produits-Image-' + this.marque.id);
        if (mediaProduct.url) {
          return mediaProduct.url;
        } else {
          return require(`../assets/image-marque/${mediaProduct.filename}`);
        }
      }
    },
    logoPath() {
      if (this.marque === 'essilor') {
        var mediaEssilor = this.$store.getters.getMediaById('Produits-SVG-' + this.marque + 'White');
        if (mediaEssilor.url) {
          return mediaEssilor.url;
        } else {
          return require(`../assets/logo-marque/${mediaEssilor.filename}`);
        }
      } else {
        var mediaProduct = this.$store.getters.getMediaById('Produits-SVG-' + this.marque.id + 'White');
        if (mediaProduct.url) {
          return mediaProduct.url;
        } else {
          return require(`../assets/logo-marque/${mediaProduct.filename}`);
        }
      }
    },
    logoPathBlack() {
      if (this.marque === 'essilor') {
        var mediaEssilor = this.$store.getters.getMediaById('Produits-SVG-' + this.marque + 'Black');
        if (mediaEssilor.url) {
          return mediaEssilor.url;
        } else {
          return require(`../assets/logo-marque/${mediaEssilor.filename}`);
        }
      } else {
        var mediaProduct = this.$store.getters.getMediaById('Produits-SVG-' + this.marque.id + 'Black');
        if (mediaProduct.url) {
          return mediaProduct.url;
        } else {
          return require(`../assets/logo-marque/${mediaProduct.filename}`);
        }
      }
    },
  },
  methods: {
    //redirect to the right video
    goToVideo(brand) {
      var videoLink = '';
      switch (brand) {
        case 'Produits-Bouton-PourquoiEssilor':
          videoLink = this.$store.getters.getMediaById(`Produits-Youtube-PourquoiEssilor`);
          break;
        case 'Produits-Bouton-FabricationVerre':
          videoLink = this.$store.getters.getMediaById(`Produits-Youtube-FabricationVerres`);
          break;
        case 'Produits-Bouton-OrigineGarantie':
          videoLink = this.$store.getters.getMediaById(`Produits-Youtube-OrigineFrance`);
          break;
      }
      if (videoLink) {
        var youtubeId = videoLink.url.split('/');
        this.$router.push(`/player/product/${youtubeId.pop()}/${brand}`);
      }
    },
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    mouseover: function() {
      this.selecting = true;
      if (this.hover === 'false') {
        this.$emit('changehoverValue');
      }
    },
    mouseleave: function() {
      if (this.hover === 'false') {
        this.selecting = false;
      }
      if (this.hover === 'true') {
        this.$emit('changehoverValue');
      }
    },
    goToConfigurator(product) {
      this.$store.commit('selectProduct', {
        category: product.category,
        productId: product.id,
      });
      this.$router.push({ path: this.$store.getters.getDemoLink(product.demos[0].id) + '?origin=decouvrirProduit' });
    },
  },
  mounted() {
    if (this.hover === 'true') {
      this.selecting = true;
    }
  },
  watch: {
    hover: function() {
      if (this.hover === 'false') {
        this.selecting = false;
      }
    },
  },
};
</script>

<style scoped>
.logo-container {
  margin-bottom: 30px;
}

.link-container {
  height: 50%;
}
.logo-essi {
  width: 60%;
}

.logo-essi-first {
  width: 30%;
}

.selectMenu {
  width: 100%;
  height: 100%;
  background-color: white;
  padding-top: 50px;
}

.slide-content {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

button {
  border: none;
  background-color: white;
}
.logo-essilor {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  z-index: 10;
}
.logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  z-index: 10;
}

.slideImage {
  justify-content: center;
  align-items: center;
  position: relative;
}

.productButton {
  width: auto;
  margin-bottom: 30px;
  font-size: 20px;
  display: block;
  margin-bottom: 10px;
  margin: auto;
  text-align: center;
  color: grey;
  padding-top: 10px;
  padding-bottom: 10px;
}

.productButton:hover {
  color: black;
}

.productButton:hover::after {
  content: '';
  display: block;

  padding-top: 4px;
  width: 55px;

  text-align: center;
  border-bottom: 1px solid#E6EDF5;
}

.link-video {
  font-size: 20px;
  display: flex;
  width: 70%;
  font-size: 18px;
  margin: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

.link-video button {
  margin-left: 16px;
}

.link-video img {
  height: 23px;
}

.link {
  color: black;
  cursor: pointer;
}

.essilor {
  height: 44%;
  width: 70%;
  margin: auto;
  border-top: 1px solid lightgray;
}

.container-intro {
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 50px;
}
.intro {
  font-family: AkhandSoft;
  font-size: 23px;
  font-weight: 310;
  line-height: 1.7;
  letter-spacing: 0.6px;
  text-align: center;
  color: #000000;
}

.introSmall {
  font-family: AkhandSoft;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.6;
  letter-spacing: 0.5px;
  text-align: center;
  color: #000000;
}

/*Compatibility for IE 11*/
@media screen and (min-width: 0\0) {
  .logo {
    position: absolute;
    z-index: 10;
    top: 50%;
    left: 22%;
  }

  .logo:nth-child(0n + 1) {
    left: 33% !important;
  }
}

@media only screen and (max-width: 1024px) {
  .intro {
    font-size: 18px;
  }
  .logo-container {
    margin-bottom: 10px;
  }
}
</style>
